<template>
    <Link
        :href="route('login')"
        class="block w-full font-semibold text-[#524E56] text-center border border-[#524E56] rounded-lg px-4 py-3.5"
    >
        {{ __('page.login.nav_title') }}
    </Link>
</template>
